import React, { useEffect } from 'react';
import { getStats } from '../../actions/adminAction';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../layout/Loder';
import './Stats.css';
import './Admin.css';

const Stat = ({ label, value, sub }) => (
  <div className="as-card">
    <div className="as-card-value">{value ?? '—'}</div>
    <div className="as-card-label">{label}</div>
    {sub && <div className="as-card-sub">{sub}</div>}
  </div>
);

const Stats = () => {
  const dispatch = useDispatch();
  const s = useSelector((state) => state.stats);

  useEffect(() => { dispatch(getStats()); }, []);

  if (s.loading) return <Loader />;

  const releaseRate = s.totalPosts > 0
    ? ((s.releasedPosts / s.totalPosts) * 100).toFixed(1)
    : '0.0';

  const aiAdoptionRate = s.totalUsers > 0
    ? ((s.aiAccessUsers / s.totalUsers) * 100).toFixed(1)
    : '0.0';

  // Bar chart for signups per day (last 30 days)
  const maxSignups = s.signupsPerDay?.length
    ? Math.max(...s.signupsPerDay.map(d => d.count), 1)
    : 1;

  return (
    <div className="as-page">
      <div className="as-header">
        <div className="as-eyebrow">Admin</div>
        <h1 className="as-title">Analytics</h1>
        <p className="as-subtitle">Live data from production.</p>
      </div>

      {/* ── Growth ── */}
      <section className="as-section">
        <div className="as-section-label">Growth</div>
        <div className="as-grid as-grid-4">
          <Stat label="Total Users" value={s.totalUsers} />
          <Stat label="New Today" value={s.newUsersToday} />
          <Stat label="New This Week" value={s.newUsersLast7} />
          <Stat label="New This Month" value={s.newUsersLast30} />
        </div>
      </section>

      {/* ── Nodes ── */}
      <section className="as-section">
        <div className="as-section-label">Records</div>
        <div className="as-grid as-grid-4">
          <Stat label="Total Records" value={s.totalPosts} />
          <Stat label="Active" value={s.activePosts} />
          <Stat label="Standby" value={s.standbyPosts} />
          <Stat label="Released" value={s.releasedPosts} sub={`${releaseRate}% release rate`} />
        </div>
        <div className="as-grid as-grid-2" style={{ marginTop: '1rem' }}>
          <Stat label="New Records (7d)" value={s.newNodesLast7} />
          <Stat label="New Records (30d)" value={s.newNodesLast30} />
        </div>
      </section>

      {/* ── AI ── */}
      <section className="as-section">
        <div className="as-section-label">Dmyor Assist</div>
        <div className="as-grid as-grid-2">
          <Stat label="AI Access Users" value={s.aiAccessUsers} sub={`${aiAdoptionRate}% of all users`} />
          <Stat label="Non-AI Users" value={s.totalUsers - s.aiAccessUsers} />
        </div>
      </section>

      {/* ── Signup trend ── */}
      {s.signupsPerDay?.length > 0 && (
        <section className="as-section">
          <div className="as-section-label">Signups — last 30 days</div>
          <div className="as-bar-chart">
            {s.signupsPerDay.map((d) => (
              <div key={d._id} className="as-bar-col" title={`${d._id}: ${d.count}`}>
                <div
                  className="as-bar"
                  style={{ height: `${(d.count / maxSignups) * 100}%` }}
                />
                <div className="as-bar-date">{d._id.slice(5)}</div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* ── Node categories ── */}
      {s.nodesPerCategory?.length > 0 && (
        <section className="as-section">
          <div className="as-section-label">Records by Category</div>
          <div className="as-category-list">
            {s.nodesPerCategory.map((c) => {
              const pct = ((c.count / s.totalPosts) * 100).toFixed(1);
              return (
                <div key={c._id} className="as-category-row">
                  <div className="as-category-name">{c._id || 'other'}</div>
                  <div className="as-category-bar-wrap">
                    <div className="as-category-bar" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="as-category-count">{c.count}</div>
                  <div className="as-category-pct">{pct}%</div>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
};

export default Stats;
